import React from "react"
import { useAbility } from '@casl/react'
import { AbilityContext } from "@src/utility/context/Can"

const CanCall = (props) => {
  const action = _.isString(props.action) ? _.split(props.action, '|') : props.action 
  const ability = useAbility(AbilityContext)
  const isAllowed = action.some(subject => ability.can('call', subject))
  return isAllowed ? <>{props.children}</> : null
}

export default CanCall